var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "capusta-title",
    on: {
      "click": _vm.onRedirect
    }
  }, [_c('div', {
    staticClass: "route-back-icon",
    class: {
      'outside': _vm.isIconOutside
    }
  }), _vm.isShownTitle ? _c('div', {
    staticClass: "title-container"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm.description ? _c('div', {
    staticClass: "description-container"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }